const VOTOS_KEY = "categoriasVotadas";
const VOTO_CONFIRMADO_KEY = "votoConfirmado";

const isVotoConfirmado = (): boolean => {
  return localStorage.getItem(VOTO_CONFIRMADO_KEY) === "true";
};

export const marcarVotoConfirmado = (): void => {
  localStorage.setItem(VOTO_CONFIRMADO_KEY, "true");
};

export const verificarELimparCacheSeNecessario = (): void => {
  const votoConfirmado = isVotoConfirmado();
  const temCategorias = localStorage.getItem(VOTOS_KEY);

  if (temCategorias && !votoConfirmado) {
    resetarTudo();
  }
};

export const getCategoriasVotadas = (): string[] => {
  try {
    const stored = localStorage.getItem(VOTOS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored) as unknown;
      if (Array.isArray(parsed) && parsed.every((item): item is string => typeof item === "string")) {
        return parsed;
      }
    }
    return [];
  } catch {
    return [];
  }
};

export const salvarCategoriaVotada = (categoria: string): void => {
  const atuais = getCategoriasVotadas();
  const atualizadas = [...new Set([...atuais, categoria])];
  localStorage.setItem(VOTOS_KEY, JSON.stringify(atualizadas));
};

const limparCache = (): void => {
  localStorage.removeItem(VOTOS_KEY);
};

const resetarTudo = (): void => {
  localStorage.removeItem(VOTOS_KEY);
  localStorage.removeItem(VOTO_CONFIRMADO_KEY);
};

type VotosDebug = {
  reset: () => void;
  limpar: () => void;
  categorias: () => string[];
  confirmado: () => boolean;
  marcarConfirmado: () => void;
};

declare global {
  interface Window {
    votosDebug?: VotosDebug;
  }
}

if (import.meta.env.DEV) {
  window.votosDebug = {
    reset: resetarTudo,
    limpar: limparCache,
    categorias: getCategoriasVotadas,
    confirmado: isVotoConfirmado,
    marcarConfirmado: marcarVotoConfirmado
  };
}
